import React, { useState, useEffect, useRef } from 'react';
import { toast } from 'react-toastify';
import {
  resolveSearch,
  SEARCH_FUSE_OPTIONS,
  withSearchAliases,
} from '../utils/conditionSearch';
import { Row, Col } from 'react-bootstrap';
import Image from 'next/image';
import Link from 'next/link';
import {
  SearchFilter,
  ArrowRightBlack,
  SearchIcon,
  SearchButton,
} from '../assets/icons';
import { notFoundFolder, testDisease } from '../assets/images';
import Slider from 'react-slick';
import { useDocContext } from '../context/DocContext';
import { ReactSearchAutocomplete } from 'react-search-autocomplete';
import { useRouter } from 'next/router';
import { AddSearchTerm } from '../DB/DB';

const ServicesHomeNew = ({ categories, allConditions }) => {
  const sliderRef = useRef(null);
  const { hasSubscription } = useDocContext();
  const [isMobile, setIsMobile] = useState(false);
  const router = useRouter();
  const [searchTerm, setSearchTerm] = useState('');
  const [searchResults, setSearchResults] = useState([]);
  const [showAllConditions, setShowAllConditions] = useState(false);
  const [currentCategory, setCurrentCategory] = useState(
    categories?.[0]?.objectId || '2Kgao212j3'
  );
  const currentCat = categories.find((cat) => cat.objectId === currentCategory);
  const diseases = currentCat?.diseases || [];

  const VISIBLE_LIMIT = 9;
  const visibleDiseases = showAllConditions
    ? diseases
    : diseases.slice(0, VISIBLE_LIMIT);
  const handleOnSelect = async (e) => {
    await AddSearchTerm(e.title, e.objectId);
    const targetPath = `/${e.category.slug}/${e.slug}`;
    router.push(targetPath);
  };
  const handleOnSearch = async (string, results) => {
    //for checking the search terms
    //console.log('IN THE HANDLE ON SEARCH', string, results?.[0]?.objectId);
    setSearchTerm(string);
    setSearchResults(results);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const match = resolveSearch(searchTerm, searchResults);
    if (!match) {
      // Nothing we treat matched. Saying so beats dropping the patient on
      // whichever condition scored least badly, which is what the old
      // unconditional searchResults[0] push did.
      if (searchTerm) {
        toast.info(
          `We don't currently treat "${searchTerm}". Try browsing our conditions below.`
        );
      }
      return;
    }
    await AddSearchTerm(searchTerm, match.objectId);
    router.push(`/${match.category.slug}/${match.slug}`);
  };
  const formatResult = (item) => {
    return (
      <>
        <span className='conditionName'>{item.title}</span>
      </>
    );
  };
  // Check screen size on mount and resize
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 1024);
    };

    // Initial check
    checkMobile();

    // Add resize listener
    window.addEventListener('resize', checkMobile);

    // Cleanup
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  // Find the index of the currently selected category
  const currentIndex = categories.findIndex(
    (cat) => cat.objectId === currentCategory
  );

  // Use effect to update slider position when currentCategory changes
  useEffect(() => {
    if (sliderRef.current && currentIndex !== -1) {
      // Move to the slide containing the active category
      sliderRef.current.slickGoTo(currentIndex);
    }
  }, [currentCategory, currentIndex]);
  useEffect(() => {
    setShowAllConditions(false);
  }, [currentCategory]);

  const handleClick = (id) => {
    //console.log('ID', id);
    setCurrentCategory(id);
    //console.log('active id', currentCategory);
  };
  var settings = {
    dots: true,
    infinite: false,
    speed: 500,
    arrows: false,
    slidesToShow: 2,
    slidesToScroll: 1,
    //initialSlide: 0,
    initialSlide: currentIndex !== -1 ? currentIndex : 0,
    variableWidth: true,
    responsive: [
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          initialSlide: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 2,
        },
      },
    ],
  };

  const CategoriesLarge = () => {
    return (
      <div className='tw-flex tw-items-center tw-w-full tw-gap-x-4 2xl:tw-justify-between'>
        <div className='serviceCategoryList tw-flex tw-gap-x-4 tw-overflow-x-auto tw-whitespace-nowrap tw-min-w-0'>
          {categories
            .filter(
              (cat) =>
                cat.objectId !== 'H6Klqxne58' &&
                cat.objectId !== '1LHzR8eHNc' &&
                cat.objectId !== 'iezHwCrWYY'
            )
            .map((cat) => (
              <button
                key={cat.objectId}
                onClick={() => handleClick(cat.objectId)}
                className={` tw-flex-1 tw-h-[58px] tw-shrink-0 tw-inline-flex tw-items-center tw-justify-center tw-rounded-2xl tw-text-sm tw-cursor-pointer tw-whitespace-nowrap tw-tracking-[.75px] tw-border-0 ${
                  cat.objectId === currentCategory
                    ? 'active-cat'
                    : 'tw-bg-black tw-text-white'
                }`}
              >
                {cat.title}
              </button>
            ))}
        </div>
      </div>
    );
  };
  const CategoriesMobile = () => {
    return (
      <div className=''>
        <div className=''>
          <Slider ref={sliderRef} {...settings}>
            {categories
              .filter(
                (cat) =>
                  cat.objectId !== 'H6Klqxne58' &&
                  cat.objectId !== '1LHzR8eHNc' &&
                  cat.objectId !== 'iezHwCrWYY'
              )
              .map((cat) => (
                <div key={cat.objectId} className='tw-mr-4'>
                  <button
                    onClick={() => handleClick(cat.objectId)}
                    className={`${
                      cat.objectId === currentCategory
                        ? 'active-cat tw-w-[224px] tw-h-[58px] tw-text-sm tw-whitespace-nowrap tw-border-0  tw-tracking-[.75px]'
                        : ' tw-tracking-[.75px] tw-border-0 tw-w-[224px] tw-h-[58px] tw-bg-black tw-text-white tw-rounded-2xl tw-text-sm tw-text-center tw-cursor-pointer tw-whitespace-nowrap'
                    }`}
                  >
                    {cat.title}
                  </button>
                </div>
              ))}
          </Slider>
        </div>
      </div>
    );
  };
  return (
    <section
      className='servicesHeroWrapper'
      style={{ background: '#fff' }}
      id='services'
    >
      <div className='servicesHeroContainerHome tw-flex tw-flex-col'>
        {' '}
        <p className=' tw-text-ribbon_blue lg:tw-text-xl tw-font-medium tw-mb-4 tw-leading-[28px]'>
          40+ Conditions Covered
        </p>
        <div className='servicesHeroHomeContainer'>
          <div className='serviceHeroContentHome tw-mb-6'>
            <h2 className='serviceHeadingHome '>
              Find the care
              <span className='gradientText'> you need</span>
            </h2>
            <p className='serviceParaHome !tw-text-base'>
              Starting at just $39.99 , access expert care for everything{' '}
              <br className='tw-hidden lg:tw-block' /> from acne to allergies,
              anytime, anywhere.
            </p>
          </div>
          <form onSubmit={handleSubmit} className='tw-w-full tw-mb-4'>
            <div className=' tw-mb-0 tw-relative'>
              <div className='tw-w-full tw-relative'>
                {' '}
                <button
                  type='submit'
                  aria-label='Search conditions'
                  className='tw-absolute tw-z-50 tw-border-none tw-top-[8px] lg:tw-top-[6px]  tw-right-4 lg:tw-right-6 tw-bg-transparent'
                >
                  <SearchButton />
                </button>
              </div>

              <ReactSearchAutocomplete
                items={withSearchAliases(allConditions)}
                onSearch={handleOnSearch}
                onSelect={handleOnSelect}
                resultStringKeyName='title'
                fuseOptions={SEARCH_FUSE_OPTIONS}
                formatResult={formatResult}
                placeholder='Search Condition'
                maxResults={5}
                className='diseaseSearchBarHome'
              />
            </div>
          </form>
          {/* This is where the cateogory tabs are */}
          {isMobile ? <CategoriesMobile /> : <CategoriesLarge />}
        </div>
      </div>
      <div className='diseasesHome'>
        {/* This is where the active tag content will go */}

        <Row className='g-3'>
          {diseases.length > 0 ? (
            <>
              {visibleDiseases.map((disease) => (
                <Col xs={12} md={6} lg={4} key={disease.objectId}>
                  <Link
                    href={`/services/${disease.objectId}/${disease.title
                      .toLowerCase()
                      .replace(/[\s+#]/g, '-')}`}
                  >
                    <div className='theDiseaseBtnHomeNew'>
                      <div className='diseaseImage'>
                        <Image
                          src={disease.thumbnail || testDisease}
                          layout='fill'
                          objectFit='contain'
                          alt='the image'
                        />
                      </div>

                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'row',
                          alignItems: 'center',
                          justifyContent: 'space-between',
                          width: '100%',
                        }}
                      >
                        <div>
                          <p className='tw-capitalize tw-text-lg tw-font-medium tw-m-0 tw-p-0 tw-whitespace-nowrap tw-overflow-hidden tw-text-ellipsis tw-max-w-[225px] lg:tw-max-w-[150px] XL:tw-max-w-[250px]'>
                            {disease.title}
                          </p>

                          <span
                            style={{
                              color: '#606060',
                              fontSize: '1rem',
                              margin: '0',
                              padding: '0',
                            }}
                          >
                            Starting at just $
                            {hasSubscription ? '20.00' : disease?.Price}
                          </span>
                        </div>

                        <div className='cta-arrows'>
                          <ArrowRightBlack />
                        </div>
                      </div>
                    </div>
                  </Link>
                </Col>
              ))}

              {/* View all button */}
              {diseases.length > VISIBLE_LIMIT && (
                <div className='tw-w-full tw-flex tw-justify-center tw-mt-6'>
                  <button
                    type='button'
                    className='tw-text-base tw-font-medium tw-border tw-border-[#d8d8d8] tw-border-solid tw-rounded-full tw-px-16 tw-py-[.85rem] tw-bg-transparent hover-scale'
                    onClick={() => setShowAllConditions((v) => !v)}
                  >
                    {showAllConditions ? 'View less' : 'View all conditions'}
                  </button>
                </div>
              )}
            </>
          ) : (
            <div className='diseaseNotFoundDiv'>
              <Image
                src={notFoundFolder}
                width={64}
                height={64}
                alt='service-not-found-image'
              />
              <p className='diseaseNotFoundPara'>
                Unfortunately, we don&apos;t treat this condition
              </p>
            </div>
          )}
        </Row>
      </div>
    </section>
  );
};

export default ServicesHomeNew;

// const SearchIcon = () => (
//   <svg
//     width='32'
//     height='32'
//     viewBox='0 0 32 32'
//     fill='none'
//     xmlns='http://www.w3.org/2000/svg'
//   >
//     <rect width='24' height='24' rx='16' fill='#1E1E1E' />
//     <path
//       d='M22.9936 22.9938L19.6134 19.6135M21.4395 15.223C21.4395 18.6563 18.6562 21.4396 15.2229 21.4396C11.7895 21.4396 9.00623 18.6563 9.00623 15.223C9.00623 11.7896 11.7895 9.00635 15.2229 9.00635C18.6562 9.00635 21.4395 11.7896 21.4395 15.223Z'
//       stroke='white'
//       stroke-width='1.14183'
//       strokeLinecap='round'
//       strokeLinejoin='round'
//     />
//   </svg>
// );
